import OAuth2Service from './OAuth2Service';
import has from 'lodash/has';

function authenticate(fn, credInfo) {
  const clientId = credInfo['bigquery.client_id'];
  const clientSecret = credInfo['bigquery.client_secret'];
  const oauth2Params = {
    'oauth2.auth_url': 'https://accounts.google.com/o/oauth2/v2/auth',
    'oauth2.auth_url_param.client_id': clientId,
    'oauth2.auth_url_param.scope':
      'https://www.googleapis.com/auth/bigquery https://www.googleapis.com/auth/devstorage.read_write',
    'oauth2.auth_url_param.state': 'security_token%3D138r5719ru3e1',
    'oauth2.auth_url_param.response_type': 'code',
    'oauth2.auth_url_param.access_type': 'offline',
    'oauth2.auth_url_param.include_granted_scopes': 'true',
    'oauth2.auth_url_param.prompt': 'consent',
    'oauth2.token_url': 'https://www.googleapis.com/oauth2/v4/token',
    'oauth2.token_url_param.client_id': clientId,
    'oauth2.token_url_param.client_secret': clientSecret,
    'oauth2.token_url_param.grant_type': 'authorization_code',
  };
  const credStaticInfo = {
    'auth.type': 'OAUTH2',
    'oauth2.client.id': clientId,
    'oauth2.client.secret': clientSecret,
    'oauth2.token.type.override': 'Bearer',
    'oauth2.access.token.method': 'POST',
    'oauth2.access.token.url': 'https://www.googleapis.com/oauth2/v4/token',
    'vendor.refresh_url': 'https://www.googleapis.com/oauth2/v4/token',
    'vendor.auth_scheme': 'header',
  };
  return OAuth2Service.authenticate((authInfo, error) => {
    if (authInfo && has(authInfo, 'access_token')) {
      fn({ ...credStaticInfo, ...authInfo }, null);
    } else {
      fn(null, error);
    }
  }, oauth2Params);
}

export default {
  authenticate,
};
